import { render, staticRenderFns } from "./realtimeMenu.vue?vue&type=template&id=47bfcefc&scoped=true"
import script from "./realtimeMenu.vue?vue&type=script&lang=js"
export * from "./realtimeMenu.vue?vue&type=script&lang=js"
import style0 from "../college/logo-layout.css?vue&type=style&index=0&id=47bfcefc&prod&scoped=true&lang=css&external"
import style1 from "./realtimeMenu.vue?vue&type=style&index=1&id=47bfcefc&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47bfcefc",
  null
  
)

export default component.exports